import { Button } from 'primereact/button';
import React from 'react';
import Pages from '../../../../config/Pages';
import { useHistory } from 'react-router-dom';
import styles from './Buttons.module.scss';

function Buttons({
    onVoltar,
    onSalvar = () => {},
    onEnviar = () => {},
    isView = false,
    showEnviarButton = false,
    disableButtonVoltar = false,
    disableButtonEnviar = false,
}) {
    const history = useHistory();
    return (
        <div className={`buttonsRight ${styles.buttons}`}>
            {!disableButtonVoltar && (
                <Button
                    label="Voltar"
                    icon="pi pi-arrow-left"
                    iconPos="left"
                    className="p-button-secondary"
                    type="button"
                    onClick={() =>
                        onVoltar
                            ? onVoltar()
                            : history.push(`${Pages.sei.propostaIndicador.url.list}`)
                    }
                />
            )}

            {!isView && (
                <>
                    <Button
                        label="Salvar"
                        icon="pi pi-check"
                        iconPos="left"
                        type="button"
                        className="p-button-info"
                        onClick={() => onSalvar()}
                    />
                    {showEnviarButton && (
                        <Button
                            label="Enviar para análise negocial"
                            icon="pi pi-check"
                            iconPos="left"
                            disabled={disableButtonEnviar}
                            type="button"
                            className="p-button-info"
                            onClick={() => onEnviar()}
                        />
                    )}
                </>
            )}
        </div>
    );
}

export default Buttons;
